import React, { useEffect, useRef } from "react";
import "./marketplace.css";
import MainContainer from "../../components/container/MainContainer";
import Card from "../../components/Cards/Card";
import CustomPagination from "../../components/CustomPagination/CustomPagination";
import usePagination from "../../hooks/usePagination";
import { useAppDispatch, useAppSelector } from "../../store/storeRequests";
import StoreSelectors from "../../utils/constants/StoreSelectors.constants";
import { postDetails } from "../../services/http/http.service";
import APIList from "../../utils/constants/APIList";
import { APIResponseCodes } from "../../utils/constants/keys.constants";
import { setPageData } from "../../store/pageData/pageData.slice";
import { hideLoader, showLoader } from "../../store/Loader/loader.slice";
import { message } from "../../utils/constants/Messages";
 
const MarketPlace: React.FunctionComponent<any> = () => {
  const isUIMounted = useRef(false);
  const dispatch = useAppDispatch();
 
  const { pageData } = useAppSelector(StoreSelectors.PAGE_STATE);
  const { currentItems, handlePageClick, itemsPerPage, pageNumber } = usePagination({
    from: "marketplace",
    items: typeof pageData?.groups !== "undefined" ? pageData.groups : pageData
  });
 

  const getGROUPs = async () => {
    dispatch(showLoader(message.GETTING_APIS));

  //   const currentPage = isUIMounted.current ? pageNumber + 1 : 1;
  //     const isFiltered = filterName && filterName.toLowerCase() !== "all";
  // console.log("isFiltered", isFiltered, "filterName", filterName);
  //     const payload = isFiltered
  //   ? {
  //       search: '',
  //       page_no: currentPage,
  //       group_type: filterName.toLowerCase(),
  //     }
  //   : {
  //       search: '',
  //       page_no: currentPage,
  //     };
  // const apiUrl = isFiltered ? APIList.FILTER_BY_TYPE : APIList.GET_GROUPS;

  // const response: any = await postDetails(apiUrl, payload, getGROUPs);
    const payload1 = { search: '', page_no: pageNumber + 1 };
    const payload2 = { search: '', page_no: 1 };
    const response: any = await postDetails(APIList.GET_GROUPS, isUIMounted.current ? payload1 : payload2, getGROUPs);
    if (response?.statusCode === APIResponseCodes.SUCCESS) {
      dispatch(setPageData(response.data));
      dispatch(hideLoader());
    } else {
      dispatch(hideLoader());
      console.log("Error");
    }
  };

  // useEffect(() => window.scrollTo(0, 0), [currentItems]);

  useEffect(() => {
    if (isUIMounted.current === false) {
      if (currentItems.length === 0) {
        getGROUPs();
      }
    }
    isUIMounted.current = true;
  }, []);
 
  return (
    <div className="">
      <MainContainer>
        <h2 className="text-capitalize mf-active-header scrollTo">Group's Listing</h2>
        <div className="mf-listings-container mb-4">
          {currentItems.length !== 0 ? <Card list={currentItems} from="marketplace" /> : <p className="mb-0 font-14 weight-500 text-primary-color mt-4 text-center">No Groups found...</p>}
          {pageData?.total_pages > 1 && <CustomPagination pageNumber={pageNumber - 1} itemsPerPage={itemsPerPage} handlePageClick={handlePageClick} pageCount={pageData?.total_pages} />}
        </div>
      </MainContainer>
    </div>
  );
};
 
export default MarketPlace;
